var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"container mx"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('div',{staticClass:"logo-wrapper"},[_c('img',{attrs:{"src":require("@/assets/images/dewhot_logo.png"),"alt":"dewhot logo"}})])])])])])
}]

export { render, staticRenderFns }